/* eslint-disable */
import axios from "axios";
import Cookies from "js-cookie";
import { openModal, closeModal, renderModalContent } from "./modal";
const FAVORITES_COOKIE = "swatch_favorites";
const $btnAddToFavorites = $(".js-add-to-favorites");
const $btnRemoveFromFavorites = $(".js-remove-favorite");
const modal = document.querySelector("#modal");

/**
 * renderFavoriteTemplate
 * @param {Title} Title
 * @param {Image} mage
 * @returns
 */

const addToFavoritesTemplate = content => {
  console.log(content);
  return `
		<div class="modal__after-header">

			<button class="js-close-modal modal__close"></button>

			<h3 class="modal__title modal__title--small js-title">
				<span class="text-tertiary">${content.title}</span>${arturo_vars.favorites_added}</span>
			</h3>
		</div>
		<div class="modal__body">
			<div class="modal__image">
				${content.swatch_image}
			</div>
		</div>

		<div class="modal__footer flex content-center">
			<button class="btn btn--has-icon btn--secondary js-back-to-overview">${arturo_vars.back_to_overview}</button>
			<a href="${arturo_vars.swatches_request_uri}" class="btn btn--has-icon btn--primary btn--favorite">${arturo_vars.request_samples}</a>
		</div>`;
};

/**
 * @param {*} content
 * @returns
 */
const LimitFavoritesTemplate = () => {
  return `<div class="modal__after-header">
		<button class="js-close-modal modal__close"></button>
		<h3 class="modal__title js-title">
			<span class="text-tertiary js-modal-title">${arturo_vars.request_samples}</span>
		</h3>
	</div>
	<div class="modal__body">
		<div class="modal__message">
			${arturo_vars.favorites_max}
		</div>
	</div>

	<div class="modal__footer flex content-center">
		<button class="btn btn--has-icon btn--secondary js-back-to-overview">${arturo_vars.back_to_overview}</button>
		<a href="${arturo_vars.swatches_request_uri}" class="btn btn--has-icon btn--primary btn--favorite">${arturo_vars.request_samples}</a>
	</div>`;
};

/**
 * Add ID to favorites
 */
const addToFavorites = (id, button) => {
  const favoritesCookie = getFavoritesCookie();
  let favorites = [];
  id = parseInt(id);

  // Check if the cookie consists
  if (favoritesCookie !== undefined) {
    favorites = JSON.parse(favoritesCookie);
  }
  if (favorites.includes(id)) {
    return false;
  }
  if (favorites.length >= 3) {
    const modalContent = LimitFavoritesTemplate("titel");
    renderModalContent(modalContent);
    openModal(modal);
    return false;
  }
  favorites.push(id);
  Cookies.set(FAVORITES_COOKIE, JSON.stringify(favorites));
  $(button).addClass("added-to-favorites");
  let params = new URLSearchParams();
  params.append("action", "render_favorites_modal");
  params.append("id", id);
  axios.post("/wp-admin/admin-ajax.php", params).then(res => {
    const content = res.data.result;
    const modalContent = addToFavoritesTemplate(content);
    openModal(modal);
    renderModalContent(modalContent);
  });
};

/**
 * Get Favorites
 */
const getFavoritesCookie = () => Cookies.get(FAVORITES_COOKIE);

/**
 *
 * @returns Favorites amount
 */

const getFavoritesAmount = () => {
  if (Cookies.get(FAVORITES_COOKIE) === undefined) return 0;
  return JSON.parse(Cookies.get(FAVORITES_COOKIE)).length;
};
const updateCartCount = () => {
  $('.js-cart-count').text(getFavoritesAmount());
};

/**
 * Remove Favorite
 * @param {data attribute} id
 */
const removeFavorite = id => {
  const favoritesCookie = getFavoritesCookie();
  const favorites = JSON.parse(favoritesCookie);
  const index = favorites.indexOf(id);
  if (index > -1) {
    favorites.splice(index, 1);
    Cookies.set(FAVORITES_COOKIE, JSON.stringify(favorites));
  }
};

/**
 * Star card handler [Add to favorites]
 */
$btnAddToFavorites.on("click", e => {
  const $this = $(e.currentTarget);
  const swatchId = $this.data("id");
  if ($this.hasClass("added-to-favorites") === true) {
    removeFavorite(swatchId);
    $this.removeClass("added-to-favorites");
  } else {
    addToFavorites(swatchId, $this);
  }
  updateCartCount();
  console.log(Cookies.get(FAVORITES_COOKIE));
});

/**
 * Handler remove from favorites
 */
$btnRemoveFromFavorites.on("click", e => {
  const $this = $(e.currentTarget);
  const swatchId = $this.data("id");
  removeFavorite(swatchId);
  window.location.reload();
});

/**
 * Overlay listener
 */
overlay.addEventListener("click", () => {
  const modals = document.querySelectorAll(".modal.active");
  modals.forEach(modal => {
    closeModal(modal);
  });
});

/**
 * Close modal when clicking back to overview
 */
$(document).on("click", ".js-back-to-overview", () => {
  closeModal(modal);
});

/**
 * Btn Close Modal
 */
$(document).on("click", ".js-close-modal", () => {
  closeModal(modal);
});